import * as React from "react";
import { Image, StyleSheet, TouchableOpacity, View } from "react-native";

import PropTypes from "prop-types";
import { MonoText } from "../components/StyledText";
import { Dimensions, useWindowDimensions } from "react-native";

const screenWidth = Dimensions.get("window").width;

export default function HomeScreen({ navigation }) {
  navigation.setOptions({ tabBarVisible: false });
  const window = useWindowDimensions();

  const screenHeight = Dimensions.get("screen").height;

  function getStarted() {
    navigation.navigate("Register");
  }

  function alreadyHaveAccount() {
    navigation.navigate("Login");
  }

  return (
    <View
      style={
        window.width > 900
          ? {
              marginTop: 0,
              alignItems: "center",
              minHeight: 600,
              backgroundColor: "#27bbeb",
              flex: 1,
              paddingTop: 30,
              flexGrow: 1,
              height: screenHeight,
            }
          : {
              backgroundColor: "#27bbeb",
              height: window.height,
            }
      }
    >
      <View
        style={{
          flex: 5,
          flexDirection: "row",
          backgroundColor: "#27bbeb",
          height: "100%",
          minHeight: 460,
          top: 0,
          left: 0,
          width: window.width > 900 ? 350 : window.width,
          height: screenHeight,
        }}
      >
        <View
          style={{
            flex: 1,
            top: 0,
            left: 0,
            alignItems: window.width > 900 ? "center" : "stretch",
            width: window.width > 900 ? 350 : window.width,
            height: screenHeight,
          }}
        >
          <Image
            source={require("../assets/images/robot-dev.png")}
            style={styles.welcomeImage}
          />
        </View>
        <View
          style={{
            bottom: 0,
            height: 120,
            alignSelf: "flex-end",
            width: window.width > 900 ? 350 : window.width,
          }}
        >
          <TouchableOpacity style={styles.buttonSubmit} onPress={getStarted}>
            <MonoText style={styles.buttonSubmitText}>GET STARTED</MonoText>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.buttonSubmit}
            onPress={alreadyHaveAccount}
          >
            <MonoText style={styles.buttonSubmitText}>
              I ALREADY HAVE AN ACCOUNT
            </MonoText>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

HomeScreen.navigationOptions = {
  header: null,
};

HomeScreen.propTypes = {
  text: PropTypes.string,
};

const styles = StyleSheet.create({
  buttonSubmit: {
    marginTop: 4,
    marginBottom: 4,
    borderWidth: "2px 2px 2px 2px",
    borderStyle: "solid",
    borderRadius: 14,
    borderColor: "yellow",
    backgroundColor: "#78c800",
    alignItems: "center",
    justifyContent: "space-between",
    borderWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
    borderColor: "#58a700",
    borderTopWidth: 0,
    borderBottomWidth: 4,
    paddingHorizontal: 16,
    marginHorizontal: 16,
  },
  buttonSubmitText: {
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "center",
    fontSize: 15,
    margin: 12,
    fontWeight: "700",
    color: "#fafafa",
  },
  welcomeImage: {
    width: 100,
    height: 100,
    left: screenWidth > 900 ? screenWidth / 8 - 55 : screenWidth / 2 - 50,
    top: "20%",
  },
});
